import { Pipe, PipeTransform } from '@angular/core';
import { ReportDetailItem, ReportDetailItemAggregated } from '../services/model';

@Pipe({
  name: 'reportItemDetailsAggregation',
  standalone: true,
})
export class ReportItemDetailsAggregationPipe implements PipeTransform {
  /**
   * Im Report soll je ICF-Kategorie z.B. Arat nur 1x auftaucht und dann als Durchschnitt der sub-test-Werte
   * @returns ReportDetailItem, aber hier nur den scorePercent als Durchnittswert je type!
   */
  transform(detailItems: ReportDetailItem[] | undefined): ReportDetailItemAggregated[] {
    const resultMap = new Map();

    detailItems?.forEach(({ type, scorePercent }) => {
      if (resultMap.has(type)) {
        const { total, count } = resultMap.get(type);
        resultMap.set(type, { total: total + scorePercent, count: count + 1 });
      } else {
        resultMap.set(type, { total: scorePercent, count: 1 });
      }
    });

    const detailItemsNew: ReportDetailItemAggregated[] = Array.from(resultMap, ([type, { total, count }]) => ({
      type,
      aggregatedSubTypeCount: count,
      scorePercentAverage: Math.round(total / count),
    }));
    return detailItemsNew ?? [];
  }
}
